'use strict';

module.exports = require('./Validation');


/*****************
 ** WEBPACK FOOTER
 ** ./~/rc-form-validation/lib/index.js
 ** module id = 491
 ** module chunks = 0
 **/